import { z } from 'zod';
import { ArtifactTypeSchema, JsonValueSchema } from '@terra/shared-schemas-ai';

export const BaseArtifactDtoSchema = z.object({
  id: z.string(),

  executionId: z.string().nullable(),
  traceId: z.string().nullable(),
  threadId: z.string().nullable(),

  type: ArtifactTypeSchema,

  runtimeId: z.string().nullable(),
  toolName: z.string().nullable(),
  toolCallId: z.string().nullable(),

  actionFileName: z.string().nullable(),
  actionContent: z.string().nullable(),
  actionContentSize: z.int().nullable(),

  resultFileName: z.string().nullable(),
  resultContent: z.string().nullable(),
  resultContentSize: z.int().nullable(),

  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  durationMs: z.int().nullable(),

  metadata: JsonValueSchema.nullable(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BaseArtifactDto = z.infer<typeof BaseArtifactDtoSchema>;
